import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const uploadBulkStudent = createAsyncThunk(
  "api/fetchData",
  async (data, { rejectWithValue }) => {
    let token = data.token;
    let file = data.file;
    let formdata = new FormData();
    formdata.append("file", file);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/client/upload`,
        formdata,

        {
          headers: {
            Accept: "application/json",
            Authorization: token,
          },
        }
      );
      let status = "success";
      let data = {
        status: status,
        message: response.data,
      };
      return data; // Success: return data
    } catch (error) {
      // Handle error: rejectWithValue ensures proper error handling
      let status = "error";
      let data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data;
    }
  }
);

const uploadStudentSlice = createSlice({
  name: "api",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadBulkStudent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadBulkStudent.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(uploadBulkStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default uploadStudentSlice.reducer;
